import * as React from 'react';

import { DimeDropdownMenuSeparator } from '../DimeDropdownMenu.js';
import type { DimeActionToolbarMenuItem as MenuItem } from './DimeActionToolbar.types.js';
import { DimeActionToolbarMenuGroup } from './DimeActionToolbarMenuGroup.js';
import { DimeActionToolbarMenuItem } from './DimeActionToolbarMenuItem.js';

type MenuSection = { group: string | undefined; items: [MenuItem, ...MenuItem[]] };

function toSections(items: MenuItem[]): MenuSection[] {
  const sections: MenuSection[] = [];
  for (const item of items) {
    const last = sections.at(-1);
    if (last && item.group !== undefined && last.group === item.group) last.items.push(item);
    else sections.push({ group: item.group, items: [item] });
  }
  return sections;
}

export function DimeActionToolbarMenuItems({ items }: Readonly<{ items: MenuItem[] }>) {
  return (
    <>
      {toSections(items).map((section, index) => {
        const [first] = section.items;
        const separated = first.separatorBefore || (section.group !== undefined && index > 0);
        const rendered = section.items.map((item) => (
          <DimeActionToolbarMenuItem key={item.key} item={item} />
        ));
        return (
          <React.Fragment key={first.key}>
            {separated ? <DimeDropdownMenuSeparator /> : null}
            {section.group === undefined ? (
              rendered
            ) : (
              <DimeActionToolbarMenuGroup label={section.group}>
                {rendered}
              </DimeActionToolbarMenuGroup>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
}
